import { reactive, ref, computed, onBeforeMount } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import * as apiCommon from '@/api/common'
import * as apiDashboard from '@/api/dashboard'
import * as apiMyLink from '@/api/my-link'
import * as apiNews from '@/api/news'
import * as apiQA from '@/api/qa'
import * as apiKnowledge from '@/api/knowledge'
import * as apiNote from '@/api/note'
import * as apiBrowsingHistory from '@/api/browsing-history'
import * as apiBookmark from '@/api/bookmark'
import * as _ from 'lodash'
import * as common from '@/util/common'
import { searchByKeyword, getSearchText, getIsFuzzy, getSearchCategoryName, getGASearchClass } from '@/util/search'
import { getSearchTextInputOfSearchUIParam, getIsFuzzyInputOfSearchUIParam } from '@/util/search-ui'
import { openPrecedentDetail } from '@/logic/common/CommonPrecedent'

/**
 * ダッシュボード
 */
export const getGroup = (props, context) => {

  onBeforeMount(() => {
    // 初期の検索フォームの設定(SP画面で使用)
    group1.search_text_input = getSearchTextInputOfSearchUIParam(group1.searchCategory)
    group1.is_fuzzy_input = getIsFuzzyInputOfSearchUIParam(group1.searchCategory)
  })

  const group1 = reactive({

    isAdmin: computed(() => store.getters['profile/isAdmin']),
    isWLJOP: computed(() => store.getters['profile/isWLJOP']),

    // ### ヘッダエリア ###
    // 検索ボタン＆検索フォームのGA用class(SP画面で使用)
    gaSearchClass: computed(() => {
      return getGASearchClass('dashboard', group1.searchCategory)
    }),

    // キーワード入力欄に入力した文字列(SP画面で使用)
    search_text: computed(() => {
      return getSearchText(group1.searchCategory)
    }),
    search_text_input: '', // データバインディング用(SP画面で使用)

    // 表記の揺れを含む：0(曖昧検索),1(一致検索)(SP画面で使用)
    is_fuzzy: computed(() => {
      return getIsFuzzy(group1.searchCategory)
    }),
    is_fuzzy_input: 0, // データバインディング用(SP画面で使用)

    // 検索カテゴリ（選択肢）(SP画面で使用)
    searchCategory: computed({
      get: () => {
        return store.state.search.searchCategory
      },
      set: (searchCategory) => {
        store.dispatch('search/setSearchCategory', searchCategory)
      }
    }),
    // セレクトボックス変更時に値を取り直すように(SP画面で使用)
    changeCategory: () => {
      if (store.state.common.device === 'sp') {
        searchSelect.isFocusInput = false
      }
      group1.search_text_input = group1.search_text
      group1.is_fuzzy_input = group1.is_fuzzy
    },
    // 検索カテゴリ名(SP画面で使用)
    searchCategoryName: computed(() => {
      return getSearchCategoryName(group1.searchCategory)
    }),

    /**
     * 検索を実行する
     * 用途：検索ボタン押下時
     */
    search: (options) => {

      let searchCategory
      let searchText
      let isFuzzy
      if (
        typeof options !== 'undefined' &&
        typeof options.searchCategory !== 'undefined'
      ) {
        searchCategory = options.searchCategory
        searchText = options.search_text
        isFuzzy = options.is_fuzzy
      } else {
        searchCategory = group1.searchCategory
        // searchText = group1.search_text
        // isFuzzy = group1.is_fuzzy
        searchText = group1.search_text_input
        isFuzzy = group1.is_fuzzy_input
      }

      // 検索UI(PCSearchUI/SPSearchUI)の検索テキストと曖昧フラグを更新する
      // 同画面で検索の場合用の設定
      store.dispatch('searchUI/setSearchInputOfSearchUI', { searchText: searchText, isFuzzy: isFuzzy })
      // 別画面に遷移して検索する場合用の設定
      store.dispatch('searchUI/setSearchInputOfSearchUIParam', { searchCategory: searchCategory, searchText: searchText, isFuzzy: isFuzzy })

      // 指定した検索カテゴリに対するキーワード検索を実行し、対象の検索結果画面に遷移する
      searchByKeyword(context, searchCategory, searchText, isFuzzy) 
    },

    /**
     * 詳細検索を実行する(SP画面で使用)
     * 用途：詳細検索ウィンドウの詳細検索実行ボタン押下時
     */
    searchDetail: (isResetSearchCondition) => {
      // 検索一覧画面に遷移
      if (store.state.common.device === 'sp') {
        router.push({ name: 'SPQAList' })
      } else {
        router.push({ name: 'PCQAList' })
      }
    },

    // ### ウィジェット関連 ###
    // カスタマイズ表示切替フラグ
    // （カスタマイズ画面を表示する場合はtrue、通常表示の場合false）
    isCustomize: false,
    
    // ダッシュボードのカスタマイズの設定値
    columns: 0,
    order: [],
    mylink_isVisible: true,
    information_isVisible: true,
    information_count: 0,
    knowledge_isVisible: true,
    knowledge_count: 0,
    book_isVisible: true,
    book_count: 0,
    note_isVisible: true,
    note_count: 0,
    viewLater_isVisible: true,
    viewLater_count: 0,
    bookmark_isVisible: true,
    bookmark_count: 0,
    documentDownload_isVisible: true,
    documentDownload_count: 0,
    historyOfView_isVisible: true,
    historyOfView_count: 0,

    // 重要なお知らせリスト
    important_information_list: [],
    // お知らせのカテゴリ
    targetInformationCategoryCode: 0,
    information_category_list: [],
    // マイリンクリスト
    mylink_list: [],
    // 各種ウィジェットリスト
    information_list: [],
    knowledge_list: [],
    book_product_list: [],
    book_book_list: [],
    note_list: [],
    viewLater_list: [],
    bookmark_list: [],
    documentDownload_list: [],
    historyOfView_list: [],

    // ウィジェット並び替えウィンドウ
    isChangeOrderWindowShown: false,

    // 操作対象のウィジェットのタイプ
    targetWidgetType: '',

    // マイリンク一覧ウィンドウ表示フラグ
    visibleMyLinkList: false,

    // 各ウィジェットの表示データのロード完了フラグ
    isInformationDataLoaded: false,
    isKnowledgeDataLoaded: false,
    isBookDataLoaded: false,
    isNoteDataLoaded: false,
    isViewLaterDataLoaded: false,
    isBookmarkDataLoaded: false,
    isDocumentDownloadDataLoaded: false,
    isHistoryOfViewDataLoaded: false,
    
    /**
     *  デフォルトのウィジェット表示順
     */
    getDefaultWidgetOrder: () => {
      return [
        'information', 
        'knowledge', 
        'book', 
        'note', 
        'view-later', 
        'bookmark', 
        'document-download', 
        'history-of-view'
      ]
    },

    /**
     * ダッシュボードのカスタマイズの設定データの初期化
     */
    initializeCustomizeSettings: () => {

      group1.columns = 1
      group1.order = group1.getDefaultWidgetOrder()
      group1.mylink_isVisible = true
      group1.information_isVisible = true
      group1.information_count = 5
      group1.knowledge_isVisible = true
      group1.knowledge_count = 15
      group1.book_isVisible = true
      group1.book_count = 30
      group1.note_isVisible = true
      group1.note_count = 10
      group1.viewLater_isVisible = true
      group1.viewLater_count = 10
      group1.bookmark_isVisible = true
      group1.bookmark_count = 10
      group1.documentDownload_isVisible = true
      group1.documentDownload_count = 30
      group1.historyOfView_isVisible = true
      group1.historyOfView_count = 5
    },

    /**
     * ダッシュボードのカスタマイズの設定データの保存
     */
    saveCustomizeSettings: (callback) => {

      const dataToSave = {
        'mylink': {
          'visible': group1.mylink_isVisible ? 1 : 0
        },
        'columns': group1.columns,
        'order': group1.order,
        'information': {
          'visible': group1.information_isVisible ? 1 : 0,
          'count': group1.information_count
        },
        'knowledge': {
          'visible': group1.knowledge_isVisible ? 1 : 0,
          'count': group1.knowledge_count
        },
        'book': {
          'visible': group1.book_isVisible ? 1 : 0,
          'count': group1.book_count
        },
        'note': {
          'visible': group1.note_isVisible ? 1 : 0,
          'count': group1.note_count
        },
        'view-later': {
          'visible': group1.viewLater_isVisible ? 1 : 0,
          'count': group1.viewLater_count
        },
        'bookmark': {
          'visible': group1.bookmark_isVisible ? 1 : 0,
          'count': group1.bookmark_count
        },
        'document-download': {
          'visible': group1.documentDownload_isVisible ? 1 : 0,
          'count': group1.documentDownload_count
        },
        'history-of-view': {
          'visible': group1.historyOfView_isVisible ? 1 : 0,
          'count': group1.historyOfView_count
        }
      }

      // 利用者設定更新APIをコール
      const params = {}
      params.setting_key = 'pc_dashboard_custom_settings'
      params.setting_value = dataToSave
      apiCommon.updateUserSetting(params)
        .then(response => {
          if (response) {
            const { data } = response

            // コールバック関数を実行
            callback()
          }
        })
    },

    /**
     * 初期表示
     */
    init: () => {

      // ### 重要なお知らせ一覧 ###
      // お知らせ一覧API(重要なお知らせ一覧)をコール
      const newsParams = {}
      newsParams.classification = [2, 3] // 重要度：2=重要、3=緊急 
      apiNews.list(newsParams)
        .then(response => {
          if (response) {
            const { data } = response

            const listWork = data.list ?? []

            // 画面表示用に整形
            for (let i = 0; i < listWork.length; i++) {
              if (listWork[i].classification_name !== '') {
                listWork[i].title = '【' + listWork[i].classification_name + '】' + listWork[i].title
              }
              listWork[i].publication_day = common.formatDate(listWork[i].publication_day)
            }

            group1.important_information_list = listWork
          }
        })

      // ### ダッシュボードカスタマイズ設定を取得 ###
      if (store.state.common.device === 'sp') {
        // SPの場合
        // SPはダッシュボードのカスタマイズはないので、利用者設定取得APIをコールしない

        // ウィジェットの設定値
        group1.information_isVisible = true
        group1.information_count = 30
        group1.knowledge_isVisible = true
        group1.knowledge_count = 30
        group1.historyOfView_isVisible = true
        group1.historyOfView_count = 30

        // 各ウィジェットの一覧を表示する
        group1.updateWidgetList()

      } else {
        // PCの場合
        
        // 利用者設定取得APIをコール
        const params = {}
        params.setting_key = 'pc_dashboard_custom_settings'

        apiCommon.fetchUserSetting(params)
          .then(response => {
            if (response) {
              const { data } = response

              const settingValue = data.setting_value
              let settings = {}
              if (settingValue !== '') {
                try {
                  settings = JSON.parse(settingValue)
                } catch (e) {
                }
              }

              // ダッシュボードのカスタマイズの設定データの初期化
              group1.initializeCustomizeSettings()

              if (settings) {
                if (settings.columns && (settings.columns === 1 || settings.columns === 2)) {
                  group1.columns = settings.columns
                }
                if (settings.order && Array.isArray(settings.order)) {
                  // settings.orderの順番が正であるが、
                  // もし、ウィジェットの変更が発生した場合に、
                  // settings.order(保存データ)に存在せず、defaultOrderに存在するケースに対応するため、
                  // settings.orderの後ろにdefaultOrderを結合してから、
                  // 前から順番にユニークなウィジェットを詰めていったリストを使用する。
                  const defaultOrder = group1.getDefaultWidgetOrder()
                  const listWork = settings.order.concat(defaultOrder)

                  const flagMap = {}
                  for (let i = 0; i < defaultOrder.length; i++) {
                    flagMap[defaultOrder[i]] = true
                  }

                  const newList = []
                  for (let i = 0; i < listWork.length; i++) {
                    if (flagMap[listWork[i]]) {
                      newList.push(listWork[i])
                      flagMap[listWork[i]] = false
                    }
                  }

                  group1.order = newList
                }
                if (settings.mylink && !_.isNaN(settings.mylink.visible)) {
                  group1.mylink_isVisible = (settings.mylink.visible === 1)
                }
                if (settings.information && !_.isNaN(settings.information.visible)) {
                  group1.information_isVisible = (settings.information.visible === 1)
                }
                if (settings.information && !_.isNaN(settings.information.count) && (settings.information.count >= 1 && settings.information.count <= 30)) {
                  group1.information_count = settings.information.count 
                }
                if (settings.knowledge && !_.isNaN(settings.knowledge.visible)) {
                  group1.knowledge_isVisible = (settings.knowledge.visible === 1)
                }
                if (settings.knowledge && !_.isNaN(settings.knowledge.count) && (settings.knowledge.count >= 1 && settings.knowledge.count <= 30)) {
                  group1.knowledge_count = settings.knowledge.count
                }
                if (settings.book && !_.isNaN(settings.book.visible)) {
                  group1.book_isVisible = (settings.book.visible === 1)
                }
                if (settings.book && !_.isNaN(settings.book.count) && (settings.book.count >= 1 && settings.book.count <= 30)) {
                  group1.book_count = settings.book.count
                }
                if (settings.note && !_.isNaN(settings.note.visible)) {
                  group1.note_isVisible = (settings.note.visible === 1)
                }
                if (settings.note && !_.isNaN(settings.note.count) && (settings.note.count >= 1 && settings.note.count <= 30)) {
                  group1.note_count = settings.note.count
                }
                if (settings['view-later'] && !_.isNaN(settings['view-later'].visible)) {
                  group1.viewLater_isVisible = (settings['view-later'].visible === 1)
                }
                if (settings['view-later'] && !_.isNaN(settings['view-later'].count) && (settings['view-later'].count >= 1 && settings['view-later'].count <= 30)) {
                  group1.viewLater_count = settings['view-later'].count
                }
                if (settings.bookmark && !_.isNaN(settings.bookmark.visible)) {
                  group1.bookmark_isVisible = (settings.bookmark.visible === 1)
                }
                if (settings.bookmark && !_.isNaN(settings.bookmark.count) && (settings.bookmark.count >= 1 && settings.bookmark.count <= 30)) {
                  group1.bookmark_count = settings.bookmark.count
                }
                if (settings['document-download'] && !_.isNaN(settings['document-download'].visible)) {
                  group1.documentDownload_isVisible = (settings['document-download'].visible === 1)
                }
                if (settings['document-download'] && !_.isNaN(settings['document-download'].count) && (settings['document-download'].count >= 1 && settings['document-download'].count <= 30)) {
                  group1.documentDownload_count = settings['document-download'].count
                }
                if (settings['history-of-view'] && !_.isNaN(settings['history-of-view'].visible)) {
                  group1.historyOfView_isVisible = (settings['history-of-view'].visible === 1)
                }
                if (settings['history-of-view'] && !_.isNaN(settings['history-of-view'].count) && (settings['history-of-view'].count >= 1 && settings['history-of-view'].count <= 30)) {
                  group1.historyOfView_count = settings['history-of-view'].count
                }
              }

              // 各ウィジェットの一覧を表示する
              group1.updateWidgetList()
            }
          })
      }

    },

    /**
     * 各ウィジェットの一覧を表示する
     */
    updateWidgetList: () => {

      if (store.state.common.device === 'pc') {
        // マイリンク一覧のロード
        group1.loadMyLink()
      }

      // お知らせ一覧のロード
      group1.loadInformation(0)
 
      // 最新ナレッジ一覧のロード
      group1.loadKnowledge()

      if (store.state.common.device === 'pc') {
        // 書籍一覧のロード
        group1.loadBook()

        // ノート一覧のロード
        group1.loadNote()

        // 後で見る一覧のロード
        group1.loadViewLater()

        // ブックマーク一覧のロード
        group1.loadBookmark()
      
        // 書式ダウンロード一覧のロード
        group1.loadDocumentDownload()
      }

      // 閲覧履歴一覧のロード
      group1.loadHistoryOfView()
    },

    /**
     *  マイリンク一覧のロード
     */
    loadMyLink: () => {

      // 注意：マイリンクは、非表示の場合もリロードする必要があるため、
      // group1.mylink_isVisible によらずAPIを読み込む。

      // マイリンク一覧APIをコール
      const params = {}

      apiMyLink.list(params)
        .then(response => {
          if (response) {
            const { data } = response

            group1.mylink_list = data.list ?? []
          }
        })
    },

    /**
     * お知らせ一覧のロード(ステップ1)
     */
    loadInformation: (targetCategoryId = 0) => {

      if (group1.information_isVisible) {

        group1.isInformationDataLoaded = false

        if (store.state.common.device === 'sp') {
          // SPの場合
          // お知らせのカテゴリ切り替えが無いのでカテゴリ絞り込みしない
          group1.loadInformationStep2(0)
        } else {
          // PCの場合
          if (group1.information_category_list.length === 0) {
            // カテゴリを取得していない場合

            // マスタ取得APIをコールしお知らせのカテゴリを取得
            const masterParams = {}
            masterParams.key = 'news_category'
            apiCommon.fetchMaster(masterParams)
              .then(response => {
                if (response) {
                  const { data } = response

                  group1.information_category_list = data.list ?? []

                  group1.loadInformationStep2(targetCategoryId)
                }
              })
          } else {
            // カテゴリリスト取得済みの場合
            group1.loadInformationStep2(targetCategoryId)
          }
        }
      }
    },

    /**
     * お知らせ一覧のロード(ステップ2)
     */
    loadInformationStep2: (targetCategoryId = 0) => {

      if (store.state.common.device === 'sp') {
        // SPの場合
        // お知らせのカテゴリ切り替えが無いのでカテゴリ絞り込みしない
      } else {
        // PCの場合
        if (targetCategoryId === 0) {
          if (group1.information_category_list.length > 0) {
            targetCategoryId = group1.information_category_list[0].code
          }
        }
      }

      group1.targetInformationCategoryCode = targetCategoryId

      // 利用者設定APIから取得した表示件数を指定して、お知らせ一覧APIをコール
      const params = {}
      params.start = 0
      params.per_page = group1.information_count
      if (store.state.common.device === 'sp') {
        // SPの場合
        // お知らせのカテゴリ切り替えが無いのでカテゴリ絞り込みしない
      } else {
        // PCの場合
        if (group1.targetInformationCategoryCode !== 0) {
          params.category = [group1.targetInformationCategoryCode]
        }
      }

      apiNews.list(params)
        .then(response => {
          if (response) {
            const { data } = response

            const listWork = data.list ?? []

            // 画面表示用に整形
            for (let i = 0; i < listWork.length; i++) {
              listWork[i].publication_day = common.formatDate(listWork[i].publication_day)
            }

            group1.information_list = listWork
          }
        })
        .finally(() => {
          group1.isInformationDataLoaded = true
        })
    },

    /**
     *  最新ナレッジ一覧のロード
     */ 
    loadKnowledge: () => {
      if (group1.knowledge_isVisible) {

        group1.isKnowledgeDataLoaded = false

        // 利用者設定APIから取得した表示件数を指定して、最新ナレッジ一覧APIをコール
        const params = {}
        params.start = 0
        params.per_page = group1.knowledge_count
        params.search_order = 'date'
        params.ascending = 'desc'
        params.is_paginate = 1 // 検索履歴なし

        apiKnowledge.list(params)
          .then(response => {
            if (response) {
              const { data } = response

              const listWork = data.list ?? []

              // 画面表示用に整形
              for (let i = 0; i < listWork.length; i++) {
                listWork[i].created = common.formatDate(listWork[i].created)
              }
              
              group1.knowledge_list = listWork
            }
          })
          .finally(() => {
            group1.isKnowledgeDataLoaded = true
          })
      }
    },

    /**
     * 書籍一覧のロード
     */
    loadBook: () => {

      if (group1.book_isVisible) {

        group1.isBookDataLoaded = false

        //　【仕様】
        // 書籍は全書籍を表示する。→ APIリクエストに件数を指定しない
        // 書籍ウィジェットだけに関しては、選択できる1~30は、表示件数ではなく、表示行数（高さ）にする。
        // 商品名のマージンや、書籍の1つ目のマージンは、他の書籍のマージンと異なるため、
        // 厳密な高さは指定できないので「だいたいの高さ」で対応する。
        
        // 書籍一覧APIをコール（件数指定なし。取得可能なデータを全件取得）
        const params = {}
        params.search_range = 1 // キーワード検索対象範囲：1=書籍一覧画面（キーワードを指定しないので1でも3でも良い）

        apiQA.listBooksForSearch(params)
          .then(response => {
            if (response) {
              const { data } = response

              group1.book_product_list = data.products ?? []
              group1.book_book_list = data.books ?? []
            }
          })
          .finally(() => {
            group1.isBookDataLoaded = true
          })
      }
    },

    /**
     * ノート一覧のロード
     */
    loadNote: () => {

      if (group1.note_isVisible) {

        group1.isNoteDataLoaded = false

        // 利用者設定APIから取得した表示件数を指定して、ノート一覧APIをコール
        const params = {}
        params.start = 0
        params.per_page = group1.note_count
        params.search_order = 'date'
        params.ascending = 'desc'
        params.is_paginate = 1 // 1:検索履歴を残さない

        apiNote.list(params)
          .then(response => {
            if (response) {
              const { data } = response

              const listWork = data.lists ?? []

              // 画面表示用に整形
              for (let i = 0; i < listWork.length; i++) {
                // 利用者アイコン
                const userFileId = listWork[i].user_file_id
                listWork[i].image = apiCommon.getFetchFileAPIURL(userFileId)
              }
              
              group1.note_list = listWork
            }
          })
          .finally(() => {
            group1.isNoteDataLoaded = true
          })
      }
    },

    /**
     * 後で見る一覧のロード
     */
    loadViewLater: () => {

      if (group1.viewLater_isVisible) {

        group1.isViewLaterDataLoaded = false

        // タイプを「後で見る」、利用者設定APIから取得した表示件数を指定して、ブックマーク・後で見る一覧APIをコール
        const params = {}
        params.type = 2 // 2:後で見る
        params.start = 0
        params.per_page = group1.viewLater_count
        params.search_order = 'created'
        params.ascending = 'desc'

        apiBookmark.list(params)
          .then(response => {
            if (response) {
              const { data } = response

              const listWork = data.lists ?? []

              // 画面表示用に整形
              for (let i = 0; i < listWork.length; i++) {
                listWork[i].created = common.formatDate(listWork[i].created)
              }

              group1.viewLater_list = listWork
            }
          })
          .finally(() => {
            group1.isViewLaterDataLoaded = true
          })
      }
    },

    /**
     * ブックマーク一覧のロード
     */
    loadBookmark: () => {

      if (group1.bookmark_isVisible) {

        group1.isBookmarkDataLoaded = false

        // タイプを「ブックマーク」、利用者設定APIから取得した表示件数を指定して、ブックマーク・後で見る一覧APIをコール
        const params = {}
        params.type = 1 // 1:ブックマーク
        params.start = 0
        params.per_page = group1.bookmark_count
        params.search_order = 'created'
        params.ascending = 'desc'

        apiBookmark.list(params)
          .then(response => {
            if (response) {
              const { data } = response

              const listWork = data.lists ?? []

              // 画面表示用に整形
              for (let i = 0; i < listWork.length; i++) {
                listWork[i].created = common.formatDate(listWork[i].created)
              }

              group1.bookmark_list = listWork
            }
          })
          .finally(() => {
            group1.isBookmarkDataLoaded = true
          })
      }
    },

    /**
     * 書式ダウンロード一覧のロード
     */
    loadDocumentDownload: () => {

      if (group1.documentDownload_isVisible) {

        group1.isDocumentDownloadDataLoaded = false

        // ダッシュボード書式DL一覧APIをコール（件数指定なし。取得可能なデータを全件取得）
        const params = {}
        params.start = 0
        params.per_page = group1.documentDownload_count

        apiDashboard.listFormDownloads(params)
          .then(response => {
            if (response) {
              const { data } = response

              group1.documentDownload_list = data.list ?? []
            }
          })
          .finally(() => {
            group1.isDocumentDownloadDataLoaded = true
          })
      }
    },

    /**
     * 閲覧履歴一覧のロード
     */
    loadHistoryOfView: () => {
      if (group1.historyOfView_isVisible) {

        group1.isHistoryOfViewDataLoaded = false

        // 利用者設定APIから取得した表示件数を指定して、閲覧履歴一覧APIをコール
        const params = {}
        params.start = 0
        params.per_page = group1.historyOfView_count
        params.search_order = 'created'
        params.ascending = 'desc'

        apiBrowsingHistory.list(params)
          .then(response => {
            if (response) {
              const { data } = response

              const listWork = data.lists ?? []

              // 画面表示用に整形
              for (let i = 0; i < listWork.length; i++) {
                switch (listWork[i].type) {
                  case 'qa':
                    listWork[i].type_name = 'Q&A・事例'
                    break
                  case 'knowledge':
                    listWork[i].type_name = '最新ナレッジ'
                    break
                  case 'note':
                    listWork[i].type_name = 'ノート'
                    break
                  case 'pj':
                    listWork[i].type_name = '資料検索'
                    break
                }

                listWork[i].date = common.formatDate(listWork[i].date)
              }

              group1.historyOfView_list = listWork
            }
          })
          .finally(() => {
            group1.isHistoryOfViewDataLoaded = true
          })
      }
    },

    /**
     * お知らせのページに遷移
     */
    goToInformationPage: (informationId) => {
      // 遷移先とstoreのアクション名を設定
      if (store.state.common.device === 'sp') {
        router.push({ name: 'SPInformationDetail', params: { infoId: informationId } })
      } else {
        router.push({ name: 'PCInformationDetail', params: { infoId: informationId } })
      }
    },

    /**
     * 最新ナレッジのページに遷移
     */
    goToKnowledgePage: (knowledgeId) => {

      if (store.state.common.device === 'sp') {
        router.push({ name: 'SPKnowledgeDetail', params: { knowledgeId: knowledgeId } })
      } else {
        router.push({ name: 'PCKnowledgeDetail', params: { knowledgeId: knowledgeId } })
      }
    },

    /**
     * 書籍のページに遷移
     */
    goToBookPage: (productId, bookId, bookName) => {

      // 遷移先のQA詳細ではQA IDが必須であるため、対象書籍の目次の最初の設問のQA IDを指定する

      // 書籍目次一覧APIをコール
      const params = {}
      params.book_id = bookId
      params.search_index_id = 0

      apiQA.listBookTableOfContents(params)
        .then(response => {
          if (response) {
            const { data } = response

            const list = data.list ?? []
            const qaId = list[0].id ?? 0

            store.dispatch('qa/setBookId', bookId)
            store.dispatch('qa/setBookName', bookName)
            store.dispatch('qa/setQaId', qaId)
            store.dispatch('qa/setSearchIndexId', 0)
            store.dispatch('qa/setNumberCarouselVisible', 0)

            if (store.state.common.device === 'sp') {
              router.push({ name: 'SPQADetail', params: { qaId: qaId } })
            } else {
              router.push({ name: 'PCQADetail', params: { qaId: qaId } })
            }
          }
        })
    },

    /**
     * ノートのページに遷移
     */
    goToNotePage: (noteId) => {

      store.dispatch('search/setNoteSearchParam', { id: noteId })

      if (store.state.common.device === 'sp') {
        router.push({ name: 'SPNoteList' })
      } else {
        router.push({ name: 'PCNoteList' })
      }
    },

    /**
     * 後で見るの対象ページに遷移
     */
    goToViewLaterPage: (item) => {
      group1.goToPageByTypeAndId(item)
    },

    /**
     * 書式ダウンロードのページに遷移
     * 
     * ダッシュボードの書式ダウンロードウィジェットに表示されるのは書籍名であり、
     * クリックすると、対象書籍が選択された状態の書式ダウンロード一覧画面に遷移する
     */
    goToDocumentDownload: (bookId, bookName) => {
      store.dispatch('qa/setBookId', bookId)
      store.dispatch('qa/setBookName', bookName)
      store.dispatch('qa/setQaId', 0)
      store.dispatch('qa/setSearchIndexId', 0)
      store.dispatch('qa/setNumberCarouselVisible', 0)

      if (store.state.common.device === 'sp') {
        // 書式ダウンロードはPCしか存在しない
      } else {
        router.push({ name: 'PCDocumentDownloadsList' })
      }
    },

    /**
     * ブックマークのページに遷移
     */
    goToBookmarkPage: (item) => {
      group1.goToPageByTypeAndId(item)
    },

    /**
     * 閲覧履歴のページに遷移
     */
    goToHistoryOfViewPage: (item) => {
      group1.goToPageByTypeAndId(item)
    },

    /**
     * タイプとIDで指定するページ遷移（共通処理）
     */
    goToPageByTypeAndId: (item) => {

      const type = item.type
      const id = item.id
      const latestId = item.latest_id
      const bookName = item.book_name

      if (type === 'qa') {
        let targetQaId = 0
        if (latestId !== 0) {
          targetQaId = latestId
        } else {
          targetQaId = id
        }

        // 書籍ID、QA IDを初期化（書籍ID、書籍名はQADetailで、QAIDから検索して取得する）
        store.dispatch('qa/setBookId', 0)
        store.dispatch('qa/setBookName', '')
        store.dispatch('qa/setQaId', targetQaId)
        store.dispatch('qa/setSearchIndexId', 0)
        store.dispatch('qa/setNumberCarouselVisible', 0)
  
        if (store.state.common.device === 'sp') {
          router.push({ name: 'SPQADetail', params: { qaId: targetQaId } })
        } else {
          router.push({ name: 'PCQADetail', params: { qaId: targetQaId } })
        }
      } else if (type === 'knowledge') {
        if (store.state.common.device === 'sp') {
          router.push({ name: 'SPKnowledgeDetail', params: { knowledgeId: id } })
        } else {
          router.push({ name: 'PCKnowledgeDetail', params: { knowledgeId: id } })
        }
      } else if (type === 'note') {
        store.dispatch('search/setNoteSearchParam', { id: id })

        if (store.state.common.device === 'sp') {
          router.push({ name: 'SPNoteList' })
        } else {
          router.push({ name: 'PCNoteList' })
        }
      } else if (type === 'pj') {
        // 資料検索の詳細画面を別ウィンドウで開く
        if (latestId !== 0) {
          openPrecedentDetail(latestId)
        } else {
          openPrecedentDetail(id)
        }
      }
    },


    /**
     * 「ダッシュボードのカスタマイズ」ボタンを押下した場合
     */
    onCustomizeButtonClicked: (widgetType) => {
      group1.isCustomize = true
      common.scrollAreaTop('#scroll-target')
    },


    /**
     * カスタマイズ画面：マイリンクの表示/非表示切り替え
     */
    changeMyLinkVisible: () => {
      group1.mylink_isVisible = !group1.mylink_isVisible
    },

    /**
     * カスタマイズ画面：カラム数を変更
     */
    changeColumn: (columns) => {
      group1.columns = columns
    },

    /**
     * カスタマイズ画面：ウィジェットの表示/非表示切り替え
     */
    changeWidgetVisible: ({ widgetType, isVisible}) => {
      if (widgetType === 'information') {
        group1.information_isVisible = isVisible
        if (isVisible) {
          // お知らせ一覧のロード
          group1.loadInformation(0)
        }
      } else if (widgetType === 'knowledge') {
        group1.knowledge_isVisible = isVisible
        if (isVisible) {
          // 最新ナレッジ一覧のロード
          group1.loadKnowledge()
        }
      } else if (widgetType === 'book') {
        group1.book_isVisible = isVisible
        if (isVisible) {
          // 書籍一覧のロード
          group1.loadBook()
        }
      } else if (widgetType === 'note') {
        group1.note_isVisible = isVisible
        if (isVisible) {
          // ノート一覧のロード
          group1.loadNote()
        }
      } else if (widgetType === 'view-later') {
        group1.viewLater_isVisible = isVisible
        if (isVisible) {
          // 後で見る一覧のロード
          group1.loadViewLater()
        }
      } else if (widgetType === 'bookmark') {
        group1.bookmark_isVisible = isVisible
        if (isVisible) {
          // ブックマーク一覧のロード
          group1.loadBookmark()
        }
      } else if (widgetType === 'document-download') {
        group1.documentDownload_isVisible = isVisible
        if (isVisible) {
          // 書式ダウンロード一覧のロード
          group1.loadDocumentDownload()
        }
      } else if (widgetType === 'history-of-view') {
        group1.historyOfView_isVisible = isVisible
        if (isVisible) {
          // 閲覧履歴一覧のロード
          group1.loadHistoryOfView()
        }
      }
    },

    changeWidgetCount: ({ widgetType, count}) => {
      if (widgetType === 'information') {
        group1.information_count = count
        // お知らせ一覧のロード
        group1.loadInformation()
      } else if (widgetType === 'knowledge') {
        group1.knowledge_count = count
        // 最新ナレッジ一覧のロード
        group1.loadKnowledge()
      } else if (widgetType === 'book') {
        group1.book_count = count
        // 書籍一覧のロード
        group1.loadBook()
      } else if (widgetType === 'note') {
        group1.note_count = count
        // ノート一覧のロード
        group1.loadNote()
      } else if (widgetType === 'view-later') {
        group1.viewLater_count = count
        // 後で見る一覧のロード
        group1.loadViewLater()
      } else if (widgetType === 'bookmark') {
        group1.bookmark_count = count
        // ブックマーク一覧のロード
        group1.loadBookmark()
      } else if (widgetType === 'document-download') {
        group1.documentDownload_count = count
        // 書式ダウンロード一覧のロード
        group1.loadDocumentDownload()
      } else if (widgetType === 'history-of-view') {
        group1.historyOfView_count = count
        // 閲覧履歴一覧のロード
        group1.loadHistoryOfView()
      }
    },

    /**
     * カスタマイズ画面：ウィジェット並び替えウィンドウを表示
     */
    openWidgetChangePositionWindow: ({ widgetType }) => {

      // 操作対象のウィジェットのタイプを設定
      group1.targetWidgetType = widgetType

      // ウィジェット並び替えウィンドウを表示
      group1.isChangeOrderWindowShown = true
    },

    /**
     * カスタマイズ画面：対象ウィジェットを最上位に移動
     */
    moveWidgetToTop: () => {

      const newList = []
      for (let i = 0; i < group1.order.length; i++) {
        if (group1.order[i] === group1.targetWidgetType) {
          newList.unshift(group1.order[i])
        } else {
          newList.push(group1.order[i])
        }
      }
      group1.order = newList

      // ウィジェット並び替えウィンドウを閉じる
      group1.isChangeOrderWindowShown = false
    },

    /**
     * カスタマイズ画面：対象ウィジェットを一つ上に移動
     */
    moveWidgetUpOne: () => {

      const newList = []
      for (let i = 0; i < group1.order.length; i++) {
        if (group1.order[i] === group1.targetWidgetType) {
          const last = newList.pop()
          newList.push(group1.order[i])
          if (typeof last !== 'undefined') {
            newList.push(last)
          }
        } else {
          newList.push(group1.order[i])
        }
      }
      group1.order = newList

      // ウィジェット並び替えウィンドウを閉じる
      group1.isChangeOrderWindowShown = false
    },

    /**
     * カスタマイズ画面：対象ウィジェットを一つ下に移動
     */
    moveWidgetDownOne: () => {

      const newList = []
      for (let i = group1.order.length - 1; i >= 0; i--) {
        if (group1.order[i] === group1.targetWidgetType) {
          const last = newList.pop()
          newList.push(group1.order[i])
          if (typeof last !== 'undefined') {
            newList.push(last)
          }
        } else {
          newList.push(group1.order[i])
        }
      }
      group1.order = newList.reverse()

      // ウィジェット並び替えウィンドウを閉じる
      group1.isChangeOrderWindowShown = false
    },

    /**
     * カスタマイズ画面：対象ウィジェットを最下位に移動
     */
    moveWidgetToBottom: () => {

      const newList = []
      for (let i = group1.order.length - 1; i >= 0; i--) {
        if (group1.order[i] === group1.targetWidgetType) {
          newList.unshift(group1.order[i])
        } else {
          newList.push(group1.order[i])
        }
      }
      group1.order = newList.reverse()

      // ウィジェット並び替えウィンドウを閉じる
      group1.isChangeOrderWindowShown = false
    },

    /**
     * カスタマイズ画面：「カスタマイズを保存して終了する」ボタンを押下した場合
     */
    onSaveAndQuitCustomizeButtonClicked: () => {

      // ダッシュボードのカスタマイズの設定データの保存
      group1.saveCustomizeSettings(() => {
        group1.isCustomize = false
        common.scrollAreaTop('#scroll-target')
      })
    },

    /**
     * カスタマイズ画面：「カスタマイズを初期化する」ボタンを押下した場合
     */
    onInitializeCustomizeButtonClicked: () => {

      // ダッシュボードのカスタマイズの設定データの初期化
      group1.initializeCustomizeSettings()

      // ダッシュボードのカスタマイズの設定データの保存
      group1.saveCustomizeSettings(() => {
        group1.isCustomize = false
        common.scrollAreaTop('#scroll-target')
      })
    }

  })

  const searchSelect = reactive({
    isFocusInput: false,
    currentValue: 0
  })

  return {
    group1,
    searchSelect
  }
}
